<template>
  <div id="why" class="container clearfix">
    <div id="section-features" class="heading-block title-center page-section">
      <h2>{{ $t('nonincisiontransplantation') }}</h2>
      <span>{{ $t('whyforhair') }}</span>
    </div>

    <div class="col_one_third">
      <div class="feature-box fbox-plain">
        <div class="fbox-icon">
          <a href="#">
            <img
              src="@/assets/images/icons/features/icon-30y.png"
              alt="Responsive Layout"
            />
          </a>
        </div>
        <h3>
            {{ $t('special30') }}
            <!-- 30년 비절개 모발이식 전문 -->
        </h3>
        <p>
          <pre>
          {{ $t('yearsdetail') }}
          </pre>
        </p>
      </div>
    </div>

    <div class="col_one_third">
      <div class="feature-box fbox-plain">
        <div class="fbox-icon">
          <a href="#">
            <img
              src="@/assets/images/icons/features/icon-alive.png"
              alt="Retina Graphics"
            />
          </a>
        </div>
        <h3>
          {{ $t('engraftmentrate') }}
          <!-- 97%의 높은 평균 생착률-->
        </h3> 
        <pre>
          {{ $t('descengraftment') }}
        </pre>
      </div>
    </div>
    <div class="col_one_third col_last">
      <div class="feature-box fbox-plain">
        <div class="fbox-icon">
          <a href="#">
            <img
              src="@/assets/images/icons/features/icon-1d1m.png"
              alt="Powerful Performance"
            />
          </a>
        </div>
        <h3>{{ $t('singlesurgery') }}</h3>
        <pre>
          {{ $t('descsinglesurgery') }}
        </pre>
      </div>
    </div>

    <div class="clear"></div>
    <div class="divider divider-short divider-center">
      <i class="icon-circle"></i>
    </div>
    <!-- image section -->
    <div class="col_one_third nobottommargin">
      <div class="team">
        <div class="team-image">
          <img
            src="@/assets/images/pic-story-tab1-1.jpg"
            alt="비절개법 원천기술"
          />
        </div>
        <div class="team-desc">
          <div class="team-title">
            <h4>
              <pre>{{ $t('sourcetech') }}</pre>
              <!-- 자동펀치 방식의
              <br />비절개법 원천기술 개발 -->
            </h4>
          </div>
          <div class="team-content">
            <pre>{{ $t('descsourcetech') }}</pre>
            <!-- 세계적으로 통용되고 있는
            <br />자동펀치 모낭채취법을 개발함으로써 <br />비절개법의 안정화를
            이끌었습니다. -->
          </div>
        </div>
      </div>
    </div>

    <div class="col_one_third nobottommargin">
      <div class="team">
        <div class="team-image">
          <img src="@/assets/images/pic-story-tab1-2.jpg" alt="황금모낭상" />
        </div>
        <div class="team-desc">
          <div class="team-title">
            <h4>
              {{ $t('forhairprize') }}
              <br />
              {{ $t('forhairprize2') }}
            </h4>
          </div>
          <div class="team-content">
            <pre>
              {{ $t('descprize') }}
            </pre>
            <!-- 포헤어는 독자적 펀치방식의 부분삭발
            <br />비절개법(CIT)과 무삭발 비절개법(C2G)을 <br />최초 개발하여
            황금모낭상을 수상하였습니다. -->
          </div>
        </div>
      </div>
    </div>

    <div class="col_one_third nobottommargin col_last">
      <div class="team">
        <div class="team-image">
          <img
            src="@/assets/images/pic-story-tab1-3.jpg"
            alt="고밀도 고생착 슬릿이식"
          />
        </div>
        <div class="team-desc">
          <div class="team-title">
            <h4>
                {{ $t('slit') }}
                <!-- 고밀도 고생착 슬릿이식 -->
            </h4>
          </div>
          <div class="team-content">
            <pre>
              {{ $t('descslit') }}
            </pre>
            <!-- 슬릿이식만이 가능한 고밀도, 고생착
            <br />모발이식을 통하여 자연스러운 결과를 <br />만들어냅니다. -->
          </div>
        </div>
      </div>
    </div>

    <div class="clear"></div>
    <!-- 
          <div class="divider divider-short divider-center">
      <i class="icon-circle"></i>
    </div>


      <div
      id="section-pricing"
      class="heading-block title-center nobottomborder page-section"
    >
      <h2>Pricing Details</h2>
      <span>Our All inclusive Pricing Plan that covers you well</span>
    </div>

    <div class="pricing-box pricing-extended bottommargin clearfix">
      <div class="pricing-desc">
        <div class="pricing-title">
          <h3>How many Themes can you Download today?</h3>
        </div>
        <div class="pricing-features">
          <ul class="iconlist-color clearfix">
            <li><i class="icon-desktop"></i> Ultra Responsive Layouts</li>
            <li><i class="icon-eye-open"></i> Retina Ready Designs</li>
            <li><i class="icon-beaker"></i> Advanced Admin Panel</li>
            <li><i class="icon-magic"></i> Tons of Customization Options</li>
            <li><i class="icon-font"></i> Support for Custom Fonts</li>
            <li><i class="icon-stack3"></i> Premium Sliders Included</li>
            <li><i class="icon-file2"></i> Photoshop Source Files Included</li>
            <li><i class="icon-support"></i> 24x7 Priority Email Support</li>
          </ul>
        </div>
      </div>

      <div class="pricing-action-area">
        <div class="pricing-meta">
          As Low as
        </div>
        <div class="pricing-price">
          <span class="price-unit">&euro;</span>39<span class="price-tenure"
            >monthly</span
          >
        </div>
        <div class="pricing-action">
          <a href="#" class="button button-3d button-large btn-block nomargin"
            >Get Started</a
          >
        </div>
      </div>
    </div> -->

    <div class="clear"></div>
  </div>
</template>

<script>
export default {
  name: "LandingWhy"
};
</script>

<style scoped>
pre {  
  clear: both !important;
  white-space: pre-line;
}
</style>
